import { RxTriangleDown } from 'react-icons/rx';
import { Center, Image, Paper, PaperBaseProps, Popover } from '@mantine/core';

import { getCropImage } from 'util/overviewResultsDisplay';

type Props = {
  crop?: string;
  /** @default "sm" */
  shadow?: PaperBaseProps['shadow'];
};

const CropSelectPopoverTarget = ({ crop, shadow = 'sm' }: Props) => {
  return (
    <Popover.Target>
      <Paper shadow={shadow} withBorder style={{ cursor: 'pointer' }}>
        <Center pos="relative" h="3rem" w="3rem" mx="auto">
          <Image fit="contain" p={8} src={getCropImage(crop)} />
          <RxTriangleDown
            style={{
              position: 'absolute',
              bottom: 0,
              right: 0,
            }}
          />
        </Center>
      </Paper>
    </Popover.Target>
  );
};

export default CropSelectPopoverTarget;
